// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file sync_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sync_service.proto.
 */
export const file_sync_service: GenFile = /*@__PURE__*/
  fileDesc("ChJzeW5jX3NlcnZpY2UucHJvdG8SBmRvbWFpbiIWChRTdHJlYW1pbmdTeW5jUmVxdWVzdCIVChNMb25nUG9sbFN5bmNSZXF1ZXN0IiUKC1N5bmNSZXF1ZXN0EhYKDmZjbV9tZXNzYWdlX2lkGAEgASgJIjcKDFN5bmNSZXNwb25zZRInCgtzeW5jX3VwZGF0ZRgBIAEoCzISLmRvbWFpbi5TeW5jVXBkYXRlMtABCgtTeW5jU2VydmljZRJHCg1TdHJlYW1pbmdTeW5jEhwuZG9tYWluLlN0cmVhbWluZ1N5bmNSZXF1ZXN0GhQuZG9tYWluLlN5bmNSZXNwb25zZSIAMAESQwoMTG9uZ1BvbGxTeW5jEhsuZG9tYWluLkxvbmdQb2xsU3luY1JlcXVlc3QaFC5kb21haW4uU3luY1Jlc3BvbnNlIgASMwoEU3luYxITLmRvbWFpbi5TeW5jUmVxdWVzdBoULmRvbWFpbi5TeW5jUmVzcG9uc2UiAEIwWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiYgZwcm90bzM", [file_sync_update]);

/**
 * @generated from message domain.StreamingSyncRequest
 */
export type StreamingSyncRequest = Message<"domain.StreamingSyncRequest"> & {
};

/**
 * Describes the message domain.StreamingSyncRequest.
 * Use `create(StreamingSyncRequestSchema)` to create a new message.
 */
export const StreamingSyncRequestSchema: GenMessage<StreamingSyncRequest> = /*@__PURE__*/
  messageDesc(file_sync_service, 0);

/**
 * @generated from message domain.LongPollSyncRequest
 */
export type LongPollSyncRequest = Message<"domain.LongPollSyncRequest"> & {
};

/**
 * Describes the message domain.LongPollSyncRequest.
 * Use `create(LongPollSyncRequestSchema)` to create a new message.
 */
export const LongPollSyncRequestSchema: GenMessage<LongPollSyncRequest> = /*@__PURE__*/
  messageDesc(file_sync_service, 1);

/**
 * @generated from message domain.SyncRequest
 */
export type SyncRequest = Message<"domain.SyncRequest"> & {
  /**
   * @generated from field: string fcm_message_id = 1;
   */
  fcmMessageId: string;
};

/**
 * Describes the message domain.SyncRequest.
 * Use `create(SyncRequestSchema)` to create a new message.
 */
export const SyncRequestSchema: GenMessage<SyncRequest> = /*@__PURE__*/
  messageDesc(file_sync_service, 2);

/**
 * @generated from message domain.SyncResponse
 */
export type SyncResponse = Message<"domain.SyncResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.SyncResponse.
 * Use `create(SyncResponseSchema)` to create a new message.
 */
export const SyncResponseSchema: GenMessage<SyncResponse> = /*@__PURE__*/
  messageDesc(file_sync_service, 3);

/**
 * SyncService provides methods for synchronizing state from the backend to
 * clients.
 *
 * @generated from service domain.SyncService
 */
export const SyncService: GenService<{
  /**
   * Previously used for streaming sync. Replaced by centrifuge sync.
   *
   * errors:
   * - ClientOutdated (10426): Always thrown
   *
   * @generated from rpc domain.SyncService.StreamingSync
   */
  streamingSync: {
    methodKind: "server_streaming";
    input: typeof StreamingSyncRequestSchema;
    output: typeof SyncResponseSchema;
  },
  /**
   * Previously used for streaming sync. Replaced by centrifuge sync.
   *
   * errors:
   * - ClientOutdated (10426): Always thrown
   *
   * @generated from rpc domain.SyncService.LongPollSync
   */
  longPollSync: {
    methodKind: "unary";
    input: typeof LongPollSyncRequestSchema;
    output: typeof SyncResponseSchema;
  },
  /**
   * The Sync call is a single unary request for a SyncResponse.
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.SyncService.Sync
   */
  sync: {
    methodKind: "unary";
    input: typeof SyncRequestSchema;
    output: typeof SyncResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_sync_service, 0);

